import React, { useEffect, useState } from 'react';
import { FaAngleDoubleDown, FaAngleDoubleUp, FaQrcode } from 'react-icons/fa';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import 'swiper/swiper-bundle.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';

import './PendingOrderAccordion.css';
import ReceiptModal from './ReceiptModal';
import { Navigation } from 'swiper';
import { Progress } from 'antd';
import ProgressBar from './ProgressBar';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import QRCode from '../../../Assets/Icons/qrcode3.png';
import Receipt from '../../../Assets/Icons/rcpt5.png';
import { QRCodeCanvas } from 'qrcode.react';
import { Modal } from 'react-bootstrap';

const PendingOrderAccordion = (props) => {
  const [showAll, setShowAll] = useState(false);
  const { orders } = props;

  const handleToggle = () => {
    setShowAll((prev) => !prev);
  };

  const [open, setOpen] = useState({ isOpen: false, timeLine: [] });

  console.log("open", open)

  const handleOpen = (data) => {
    setOpen({ isOpen: true, timeLine: data });
  };

  const handleClose = () => {
    setOpen({ isOpen: false, timeLine: [] });
  };

  const getAppropiateStatus = (restaurant) => {
    let hasQueue = false;
    let hasPending = false;
    let hasReady = false;
    let hasServed = false;
    let hasPreparing = false;

    restaurant?.foodItems?.forEach((foodItem) => {
      if (foodItem.foodStatus === 'Queue') hasQueue = true;
      if (foodItem.foodStatus === 'Pending') hasPending = true;
      if (foodItem.foodStatus === 'Preparing') hasPreparing = true;
      if (foodItem.foodStatus === 'Ready') hasReady = true;
      if (foodItem.foodStatus === 'Served') hasServed = true;
    });

    if (hasQueue) return 'Queue';
    else if (hasPending) return 'Pending';
    else if (hasReady) return 'Ready';
    else if (hasServed) return 'Served';
    else if (hasPreparing) return 'Preparing';
    return 'Unknown';
  };

  const getQRCode = (orderId) => {
    props.GetQRCode(orderId);
    // setQrOrderId(orderId);
    // setShowQR(true);
  };

  const getSubTotalOFComponentPrice = (item) => {
    const foodBaseSubtotal = (item?.basePrice || 0) * (item?.foodItemQuantity || 1);

    const addOnsSubtotal = (item?.addOns || []).reduce((addOnSum, addOn) => {
      const addOnBaseSubtotal = (addOn?.addOnBasePrice || 0) * (addOn?.addOnQuantity || 1);

      const addOnOptionsSubtotal = (addOn?.options || []).reduce((optSum, option) => {
        const optionBaseSubtotal = (option?.optionBasePrice || 0) * (option?.optionQuantity || 1);

        const subOptionsSubtotal = (option?.subOptions || []).reduce((subSum, subOption) => {
          return subSum + (subOption?.subOptionBasePrice || 0) * (subOption?.subOptionQuantity || 1);
        }, 0);

        return optSum + optionBaseSubtotal + subOptionsSubtotal;
      }, 0);

      return addOnSum + addOnBaseSubtotal + addOnOptionsSubtotal;
    }, 0);

    const subtotal = foodBaseSubtotal + addOnsSubtotal;
    return subtotal?.toFixed(2);
  };


  return (
    <>
      <h2 className='text-center'>Order Details</h2>
      <p className='text-center text-muted'>{orders?.length} Orders pending</p>
      <div className='pending-container mt-4'>
        {orders
          ?.sort(
            (b, a) => new Date(a?.orderDateTime) - new Date(b?.orderDateTime)
          )
          ?.map((order, index) => (
            <Accordion key={index} defaultExpanded={index === 0}>
              <AccordionSummary className='shadow'>
                <div className='d-flex justify-content-between align-items-center w-100 pending-order-accordion-header'>
                  <div className='mb-3 d-flex align-items-center'>
                    {/* Restaurant Logo on the Left */}
                    <div className='pending-restaurant-logo me-3'>
                      <img src={order.restaurantLogo} alt='logo' />
                    </div>

                    {/* Order Details on the Right */}
                    <div
                      style={{
                        color: '#371B17',
                        fontSize: '15px',
                        fontWeight: '500',
                      }}
                    >
                      <div
                        className='d-flex align-items-center'
                        style={{ gap: '20px' }}
                      >
                        <span
                          style={{
                            color: '#371B17',
                            fontSize: '15px',
                            fontWeight: '500',
                          }}
                        >
                          Order Id: {order.orderId}
                        </span>
                        <strong
                          style={{
                            color: '#371B17',
                            fontSize: '10.5px',
                            fontWeight: '400',
                          }}
                        >
                          {new Date(order.orderDateTime).toLocaleString(
                            'en-GB',
                            {
                              day: '2-digit',
                              month: '2-digit',
                              year: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true,
                            }
                          )}
                        </strong>
                      </div>
                      <strong style={{ fontWeight: '650' }}>
                        {order.restaurantName}
                      </strong>{' '}
                      <br />
                    </div>
                  </div>
                  <div className='d-flex align-items-center justify-content-center'>
                    {props.GetQRCode && (
                      <div
                        className='receipt-button'
                        style={{ marginRight: '10px' }}
                      >
                        <img
                          src={QRCode}
                          alt='QR Icon'
                          onClick={() => {
                            getQRCode(order.orderId);
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    )}

                    {/* <Modal show={showQR} onHide={() => setShowQR(false)} centered size="md">
                    <Modal.Header closeButton>
                      <Modal.Title>Order QR Code</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                      <QRCodeCanvas value={qrUrl} size={200} />
                      <p className="mt-3">{qrUrl}</p>
                    </Modal.Body>
                  </Modal> */}

                    <button
                      className='receipt-button '
                      onClick={() => handleOpen(order.timeLine)}
                    >
                      <img src={Receipt} alt='Receipt Icon' />
                    </button>

                    <button
                      // className="ready-button"
                      className='status-badge px-3 py-1 me-3'
                      style={{
                        background:
                          getAppropiateStatus(order) === 'Pending'
                            ? 'rgba(243, 156, 18, .2)'
                            : getAppropiateStatus(order) === 'Queue'
                              ? 'rgba(239, 83, 80, .2)'
                              : getAppropiateStatus(order) === 'Preparing'
                                ? 'rgba(41, 128, 185, .2)'
                                : getAppropiateStatus(order) === 'Ready'
                                  ? 'rgba(39, 174, 96, .2)'
                                  : '',
                        color:
                          getAppropiateStatus(order) === 'Pending'
                            ? 'rgb(243, 156, 18)'
                            : getAppropiateStatus(order) === 'Queue'
                              ? 'rgb(239, 83, 80)'
                              : getAppropiateStatus(order) === 'Preparing'
                                ? 'rgb(41, 128, 185)'
                                : getAppropiateStatus(order) === 'Ready'
                                  ? 'rgb(39, 174, 96)'
                                  : '',
                        border: 'none',
                        borderRadius: '20px',
                      }}
                    >
                      {/* {order?.orderStatus} */}
                      {getAppropiateStatus(order)}
                    </button>
                    <p
                      style={{ marginLeft: '1em' }}
                      className='text-color mb-0 price-tag'
                    >
                      £{order.total}
                    </p>
                  </div>
                </div>
              </AccordionSummary>

              <AccordionDetails className='bg-light mt-2'>
                <div className='order-images mb-3'>
                  <Swiper
                    spaceBetween={0}
                    slidesPerView={2.4}
                    onSlideChange={() => console.log('slide change')}
                    onSwiper={(swiper) => console.log(swiper)}
                    navigation={true}
                    breakpoints={{
                      437: {
                        slidesPerView: order?.images?.length > 1 ? 2 : 1,
                        spaceBetween: 5,
                      },
                      545: {
                        spaceBetween: 12,
                        slidesPerView: 2.4,
                      },
                      768: {
                        slidesPerView: 3,
                      },
                    }}
                  >
                    {order?.images?.map((image, idx) => (
                      <SwiperSlide
                        key={idx}
                        className='d-flex justify-content-center'
                      >
                        <div className='pending-slider-img-container'>
                          <img
                            src={image.url}
                            alt={`${order.orderId}-${idx}`}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {/* <Swiper
              spaceBetween={10} // Adjusted space between slides to reduce gap
              slidesPerView={Math.min(order.images.length, 3)} // Dynamically handle slides per view
              navigation={order.images.length > 2} // Enable navigation only if more than 2 images
              modules={[Navigation]}
              loop={order.images.length > 2} // Enable loop only if more than 2 images
              style={{ maxWidth: order.images.length === 2 ? '500px' : '750px', margin: "0 auto" }} // Center align and constrain width
            >
              {order.images.map((image, idx) => (
                <SwiperSlide
                  key={idx}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center", // Center align the images
                  }}
                >
                  <div
                    className="image-container"
                    style={{
                      width: "250px", // Fixed width
                      height: "250px", // Fixed height
                      overflow: "hidden",
                      borderRadius: "8px",
                    }}
                  >
                    <img
                      src={image.url}
                      alt={`Order ${idx}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // Ensures consistent image display
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper> */}
                </div>

                <ProgressBar order={order} />

                <p className='text-center text-secondary mb-0 fw-bold'>
                  Your order is {order.orderStatus}.
                </p>
                <p className='text-center text-secondary'>Please Wait.</p>

                <div className='row'>
                  <div className='col-md-7'>
                    {order.foodItems
                      ?.slice(0, showAll ? order.foodItems.length : 2)
                      .map((item, idx) => (
                        <div key={idx} className='order-item mb-3 p-3'>
                          <div className='d-flex justify-content-between align-items-center'>
                            <h6 className='mb-0 fw-bold'>
                              {idx + 1}) {item.foodItemName}{' '}
                              <span className='fw-normal'>
                                x{item.foodItemQuantity}
                              </span>
                              <span className='ms-2 text-muted'>
                                £{item.basePrice * item.foodItemQuantity}
                              </span>
                            </h6>
                            <div className='d-flex align-items-center'>
                              <span
                                className='status-badge px-3 py-1 me-3'
                                style={{
                                  background:
                                    item.foodStatus === 'Pending'
                                      ? 'rgba(243, 156, 18, .2)'
                                      : item.foodStatus === 'Queue'
                                        ? 'rgba(239, 83, 80, .2)'
                                        : item.foodStatus === 'Preparing'
                                          ? 'rgba(41, 128, 185, .2)'
                                          : item.foodStatus === 'Ready'
                                            ? 'rgba(39, 174, 96, .2)'
                                            : '',
                                  color:
                                    item.foodStatus === 'Pending'
                                      ? 'rgb(243, 156, 18)'
                                      : item.foodStatus === 'Queue'
                                        ? 'rgb(239, 83, 80)'
                                        : item.foodStatus === 'Preparing'
                                          ? 'rgb(41, 128, 185)'
                                          : item.foodStatus === 'Ready'
                                            ? 'rgb(39, 174, 96)'
                                            : '',
                                }}
                              >
                                {item.foodStatus}
                              </span>

                              <span className='fw-bold' style={{ minWidth: '49px' }}>
                                {/* £{item.totalFoodItemPrice} */}
                                £ {getSubTotalOFComponentPrice(item)}
                              </span>
                            </div>
                          </div>
                          {item?.addOns?.map(
                            (addOn) =>
                              addOn?.addOnQuantity > 0 && (
                                <div
                                  key={addOn.addOnId}
                                  style={{ marginLeft: '18px' }}
                                >
                                  {/* Display AddOn */}
                                  <h6>
                                    {addOn.addOnName} x{addOn.addOnQuantity}
                                    <span>
                                      {' '}
                                      £
                                      {addOn.addOnBasePrice *
                                        addOn.addOnQuantity}
                                    </span>
                                  </h6>
                                  {/* Display Options */}
                                  {addOn?.options?.map(
                                    (option) =>
                                      option?.optionQuantity > 0 && (
                                        <div
                                          key={option.optionId}
                                          style={{ marginLeft: '1rem' }}
                                        >
                                          <h6>
                                            {option.optionName} x
                                            {option.optionQuantity}
                                            <span>
                                              {' '}
                                              £
                                              {option.optionBasePrice *
                                                option.optionQuantity}
                                            </span>
                                          </h6>
                                          {/* Display SubOptions */}
                                          {option?.subOptions?.map(
                                            (subOption) => (
                                              <div
                                                key={subOption.subOptionId}
                                                style={{ marginLeft: '2rem' }}
                                              >
                                                <span>
                                                  {subOption.subOptionName} x{subOption.subOptionQuantity}
                                                  <span>
                                                    {' '}
                                                    £
                                                    {
                                                      subOption.subOptionBasePrice
                                                    }
                                                  </span>
                                                </span>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )
                                  )}
                                </div>
                              )
                          )}
                        </div>
                      ))}
                  </div>

                  <div className='col-md-5'>
                    <div className='payment-breakdown p-3 shadow-sm rounded'>
                      <h6 className='mb-3'>Payment Break Downs</h6>
                      <ul
                        className='list-unstyled'
                        style={{
                          padding: 0,
                          margin: 0,
                          fontSize: '14px',
                          color: '#555',
                        }}
                      >
                        <li className='d-flex justify-content-between mb-2'>
                          <span>Sub Total</span> <span>£{order?.subTotal?.toFixed(2)}</span>
                        </li>

                        <li className='d-flex justify-content-between mb-2'>
                          <span>Total VAT</span>{' '}
                          <span>£{order?.totalVat?.toFixed(2)}</span>
                        </li>

                        <li className='d-flex justify-content-between mb-2'>
                          <span>Total SD</span>{' '}
                          <span>£{order?.totalSD?.toFixed(2)}</span>
                        </li>

                        <li className='d-flex justify-content-between mb-2'>
                          <span>Total Service Charge Exc. VAT</span>{' '}
                          <span>£{order?.totalServiceChargeExcVat?.toFixed(2)}</span>
                        </li>
                        <li className='d-flex justify-content-between mb-2'>
                          <span>Total Service Charge VAT (20%)</span>{' '}
                          <span>£{order?.totalServiceChargeVat?.toFixed(2)}</span>
                        </li>
                        <li className='d-flex justify-content-between mb-2'>
                          <span>Total Tips</span>{' '}
                          <span>£{order?.totalTips?.toFixed(2)}</span>
                        </li>
                        <li className='d-flex justify-content-between mb-2'>
                          <span>Delivery Fee Inc. VAT (20%)</span>{' '}
                          <span>£{order?.deliveryFeeIncVat?.toFixed(2)}</span>
                        </li>
                        <li className='d-flex justify-content-between mb-2'>
                          <span>Credit</span> <span>£{order?.credit?.toFixed(2)}</span>
                        </li>
                      </ul>
                      <hr />
                      <div>
                        <h6 className='d-flex justify-content-between'>
                          <div className='d-flex flex-column'>
                            <h6 className='bold-text'>Total Price</h6>
                            <span className='fs-6'>(VAT Inc.)</span>
                          </div>
                          <h6 className='bold-text'>£{order.total?.toFixed(2)}</h6>
                        </h6>
                      </div>
                      {/* <h6 className="d-flex justify-content-between" style={{ fontWeight: 700, color: "#333" }}>
                    div
                    <span>Total Price (VAT Inc.)</span>
                     <span>£{order.total}</span>
                  </h6> */}
                    </div>
                  </div>
                </div>

                {order.foodItems?.length > 2 && (
                  <div className='text-center'>
                    <button className='see-more-btn' onClick={handleToggle}>
                      {showAll ? 'See Less' : 'See More'}
                      {showAll ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />}
                    </button>
                  </div>
                )}
              </AccordionDetails>
            </Accordion>
          ))}

        <ReceiptModal
          open={open?.isOpen}
          handleClose={handleClose}
          timeLineData={open.timeLine}
        />
      </div>
    </>
  );
};

export default PendingOrderAccordion;
